const DEFAULTS = {
  skinTone: '#F0C7A0',
  shirtColor: '#7EC8E3',
  eyeStyle: 'happy',
  eyeColor: '#5C3A21',
  hairStyle: 'messy',
  hairColor: '#5C3A21',
  facialHairStyle: 'none',
  facialHairColor: '#5C3A21',
  glassesStyle: 'none',
  glassesColor: '#4FC3F7',
  hatStyle: 'none',
  hatColor: '#2D3436',
  costumeStyle: 'none',
  backgroundColor: '#E8EBF5',
};

function hex(value, fallback) {
  const raw = typeof value === 'string' ? value.trim() : '';
  return /^#[0-9A-Fa-f]{3,8}$/.test(raw) ? raw : fallback;
}

function migrateEye(style) {
  if (style === 'wink' || style === 'tongue') return 'happy';
  return style;
}

function migrateFacialHair(style) {
  if (style === 'goatee') return 'mustache';
  return style;
}

function normalize(config = {}) {
  const eyeStyle = migrateEye(
    typeof config.eyeStyle === 'string' && config.eyeStyle
      ? config.eyeStyle
      : DEFAULTS.eyeStyle,
  );
  const facialHairStyle = migrateFacialHair(
    typeof config.facialHairStyle === 'string' && config.facialHairStyle
      ? config.facialHairStyle
      : DEFAULTS.facialHairStyle,
  );
  const str = (key) =>
    typeof config[key] === 'string' && config[key] ? config[key] : DEFAULTS[key];

  return {
    skinTone: hex(config.skinTone, DEFAULTS.skinTone),
    eyeStyle,
    eyeColor: hex(config.eyeColor, DEFAULTS.eyeColor),
    hairStyle: str('hairStyle'),
    hairColor: hex(config.hairColor, DEFAULTS.hairColor),
    facialHairStyle,
    facialHairColor: hex(config.facialHairColor, DEFAULTS.facialHairColor),
    glassesStyle: str('glassesStyle'),
    glassesColor: hex(config.glassesColor, DEFAULTS.glassesColor),
    hatStyle: str('hatStyle'),
    hatColor: hex(config.hatColor, DEFAULTS.hatColor),
    costumeStyle: str('costumeStyle'),
    backgroundColor: hex(config.backgroundColor, DEFAULTS.backgroundColor),
  };
}

function head(skin) {
  return `<g id="head">
  <circle cx="74" cy="116" r="11" fill="${skin}"/>
  <circle cx="166" cy="116" r="11" fill="${skin}"/>
  <circle cx="120" cy="116" r="50" fill="${skin}"/>
</g>`;
}

function facialHair(style, color) {
  if (style === 'none') return '';
  switch (style) {
    case 'mustache':
      return '';
    case 'stubble':
      return `<g id="facial-hair">
  <path d="M71 127 A50 50 0 0 0 169 127 C158 150 142 160 120 162 C98 160 82 150 71 127 Z" fill="${color}" fill-opacity="0.55"/>
</g>`;
    case 'thick':
      return `<g id="facial-hair">
  <path d="M71 127 A50 50 0 0 0 96 160 C106 178 134 178 144 160 A50 50 0 0 0 169 127 C152 148 136 158 120 160 C104 158 88 148 71 127 Z" fill="${color}"/>
</g>`;
    case 'bushy':
      return `<g id="facial-hair">
  <path d="M74 114 C64 138 80 166 98 176 L120 192 L142 176 C160 166 176 138 166 114 C158 132 144 148 120 152 C96 148 82 132 74 114 Z" fill="${color}"/>
</g>`;
    case 'full':
    default:
      return `<g id="facial-hair">
  <path d="M71 127 A50 50 0 0 0 169 127 C156 146 140 154 120 156 C100 154 84 146 71 127 Z" fill="${color}"/>
</g>`;
  }
}

function face(style, eyeColor, skin) {
  const whites = `
  <circle cx="98" cy="104" r="13" fill="#FFFFFF"/>
  <circle cx="142" cy="104" r="13" fill="#FFFFFF"/>`;

  let pupils = `
  <circle cx="98" cy="104" r="6.5" fill="${eyeColor}"/>
  <circle cx="142" cy="104" r="6.5" fill="${eyeColor}"/>
  <circle cx="95" cy="101" r="2.4" fill="#FFFFFF"/>
  <circle cx="139" cy="101" r="2.4" fill="#FFFFFF"/>`;

  if (style === 'cool') {
    pupils = `
  <circle cx="98" cy="106" r="6.5" fill="${eyeColor}"/>
  <circle cx="142" cy="106" r="6.5" fill="${eyeColor}"/>
  <circle cx="95" cy="103" r="2.4" fill="#FFFFFF"/>
  <circle cx="139" cy="103" r="2.4" fill="#FFFFFF"/>
  <path d="M86 94 H110" stroke="${eyeColor}" stroke-width="3" stroke-linecap="round"/>
  <path d="M130 94 H154" stroke="${eyeColor}" stroke-width="3" stroke-linecap="round"/>`;
  } else if (style === 'surprised') {
    pupils = `
  <circle cx="98" cy="104" r="7.5" fill="${eyeColor}"/>
  <circle cx="142" cy="104" r="7.5" fill="${eyeColor}"/>
  <circle cx="95" cy="101" r="2.6" fill="#FFFFFF"/>
  <circle cx="139" cy="101" r="2.6" fill="#FFFFFF"/>`;
  } else if (style === 'laugh') {
    pupils = `
  <path d="M86 104 Q98 96 110 104" stroke="${eyeColor}" stroke-width="3.5" fill="none" stroke-linecap="round"/>
  <path d="M130 104 Q142 96 154 104" stroke="${eyeColor}" stroke-width="3.5" fill="none" stroke-linecap="round"/>`;
  }

  let mouth =
    '<path d="M108 132 Q120 146 132 132" stroke="#5C3A21" stroke-width="3.5" fill="none" stroke-linecap="round"/>';
  if (style === 'neutral') {
    mouth =
      '<path d="M108 132 H132" stroke="#5C3A21" stroke-width="3.5" stroke-linecap="round"/>';
  } else if (style === 'cool') {
    mouth =
      '<path d="M110 134 Q120 130 130 134" stroke="#5C3A21" stroke-width="3.5" fill="none" stroke-linecap="round"/>';
  } else if (style === 'surprised') {
    mouth = '<ellipse cx="120" cy="134" rx="7" ry="9" fill="#5C3A21"/>';
  } else if (style === 'laugh' || style === 'grin') {
    mouth = `<path d="M104 128 Q120 150 136 128" fill="#5C3A21"/>
<path d="M110 132 Q120 144 130 132" fill="#E17055"/>`;
  }

  const nose = `<ellipse cx="120" cy="118" rx="4.5" ry="3.5" fill="${skin}" stroke="#E0A878" stroke-width="1.4"/>`;

  return `<g id="face">
  ${whites}
  ${pupils}
  ${nose}
  ${mouth}
</g>`;
}

function glasses(style, color) {
  if (style === 'none') return '';
  if (style === 'square') {
    return `<g id="glasses">
  <rect x="82" y="90" width="34" height="26" rx="7" fill="none" stroke="${color}" stroke-width="5"/>
  <rect x="124" y="90" width="34" height="26" rx="7" fill="none" stroke="${color}" stroke-width="5"/>
  <path d="M116 104 H124" stroke="${color}" stroke-width="4" stroke-linecap="round"/>
</g>`;
  }
  if (style === 'cat') {
    return `<g id="glasses">
  <path d="M80 110 Q82 88 114 92 Q114 114 98 116 Q82 116 80 110 Z" fill="none" stroke="${color}" stroke-width="5"/>
  <path d="M126 92 Q158 88 160 110 Q158 116 142 116 Q126 114 126 92 Z" fill="none" stroke="${color}" stroke-width="5"/>
  <path d="M114 102 H126" stroke="${color}" stroke-width="4" stroke-linecap="round"/>
</g>`;
  }
  return `<g id="glasses">
  <circle cx="98" cy="104" r="16" fill="none" stroke="${color}" stroke-width="5"/>
  <circle cx="142" cy="104" r="16" fill="none" stroke="${color}" stroke-width="5"/>
  <path d="M114 104 H126" stroke="${color}" stroke-width="4" stroke-linecap="round"/>
</g>`;
}

function cap(color) {
  return `<path d="M74 108 C74 66 94 52 120 52 C146 52 166 66 166 108 C156 86 140 76 120 76 C100 76 84 86 74 108 Z" fill="${color}"/>`;
}

function hair(style, color) {
  if (style === 'none') return '';
  switch (style) {
    case 'short':
      return `<g id="hair">${cap(color)}</g>`;
    case 'balding':
      return `<g id="hair">
  <path d="M72 108 C74 78 90 66 106 64 L104 88 C92 92 80 100 74 114 Z" fill="${color}"/>
  <path d="M168 108 C166 78 150 66 134 64 L136 88 C148 92 160 100 166 114 Z" fill="${color}"/>
</g>`;
    case 'curly':
      return `<g id="hair">
  ${cap(color)}
  <circle cx="84" cy="78" r="14" fill="${color}"/>
  <circle cx="104" cy="62" r="14" fill="${color}"/>
  <circle cx="120" cy="54" r="15" fill="${color}"/>
  <circle cx="136" cy="62" r="14" fill="${color}"/>
  <circle cx="156" cy="78" r="14" fill="${color}"/>
</g>`;
    case 'side':
      return `<g id="hair">
  ${cap(color)}
  <path d="M138 72 C160 78 174 104 168 136 C162 150 148 146 148 128 C156 104 154 84 138 76 Z" fill="${color}"/>
</g>`;
    case 'bob':
      return `<g id="hair">
  <path d="M68 108 C68 58 90 44 120 44 C150 44 172 58 172 108 C162 82 144 70 120 70 C96 70 78 82 68 108 Z" fill="${color}"/>
  <path d="M70 90 C50 102 46 128 54 150 C60 164 84 166 92 152 C90 134 84 108 80 90 Z" fill="${color}"/>
  <path d="M170 90 C190 102 194 128 186 150 C180 164 156 166 148 152 C150 134 156 108 160 90 Z" fill="${color}"/>
  <path d="M78 68 C98 68 110 70 120 70 C130 70 142 68 162 68 C150 86 134 92 120 90 C106 92 90 86 78 68 Z" fill="${color}"/>
</g>`;
    case 'long':
      return `<g id="hair">
  <path fill="${color}" d="
    M 102 244
    C 98 210 96 178 98 158
    C 84 144 74 118 76 100
    C 78 86 80 80 88 82
    C 104 74 136 74 152 82
    C 160 80 162 86 164 100
    C 166 118 156 144 142 158
    C 144 178 142 210 138 244
    C 148 254 168 254 180 242
    C 186 210 186 164 182 110
    C 176 62 148 40 120 40
    C 92 40 64 62 58 110
    C 54 164 54 210 60 242
    C 72 254 92 254 102 244 Z"/>
</g>`;
    case 'ponytail':
      return `<g id="hair">
  ${cap(color)}
  <path d="M150 58 C172 66 186 108 180 158 C176 178 160 174 162 154 C170 116 168 78 152 66 Z" fill="${color}"/>
</g>`;
    case 'bun':
      return `<g id="hair">
  ${cap(color)}
  <circle cx="120" cy="46" r="16" fill="${color}"/>
</g>`;
    case 'bangs':
      return `<g id="hair">
  ${cap(color)}
  <path d="M84 74 C100 92 112 90 120 86 C128 90 140 92 156 74 L150 84 C138 96 126 94 120 90 C114 94 102 96 90 84 Z" fill="${color}"/>
</g>`;
    case 'wavy':
      return `<g id="hair">
  <path fill="${color}" d="
    M 102 244
    C 98 210 96 178 98 158
    C 84 144 74 118 76 100
    C 78 86 80 80 88 82
    C 104 74 136 74 152 82
    C 160 80 162 86 164 100
    C 166 118 156 144 142 158
    C 144 178 142 210 138 244
    C 154 256 180 248 188 226
    C 196 204 188 184 178 166
    C 184 144 184 122 182 110
    C 176 62 148 40 120 40
    C 92 40 64 62 58 110
    C 56 122 56 144 62 166
    C 52 184 44 204 52 226
    C 60 248 86 256 102 244 Z"/>
</g>`;
    case 'messy':
    default:
      return `<g id="hair">
  ${cap(color)}
  <path d="M92 58 L86 40 L104 56 Z" fill="${color}"/>
  <path d="M118 50 L122 32 L134 52 Z" fill="${color}"/>
  <path d="M142 58 L158 42 L152 64 Z" fill="${color}"/>
</g>`;
  }
}

function hat(style, color) {
  if (style === 'none') return '';
  switch (style) {
    case 'cap':
      return `<g id="hat">
  <path d="M82 86 C82 56 98 44 120 44 C142 44 158 56 158 86 L158 92 L82 92 Z" fill="${color}"/>
  <ellipse cx="120" cy="88" rx="32" ry="5" fill="${color}"/>
</g>`;
    case 'beanie':
      return `<g id="hat">
  <path d="M76 100 C76 56 94 40 120 40 C146 40 164 56 164 100 L160 106 L80 106 Z" fill="${color}"/>
  <circle cx="120" cy="38" r="7" fill="${color}"/>
</g>`;
    case 'cowboy':
      return `<g id="hat">
  <path d="M92 90 C92 54 104 42 120 42 C136 42 148 54 148 90 Z" fill="${color}"/>
  <ellipse cx="120" cy="90" rx="62" ry="8" fill="${color}"/>
</g>`;
    case 'sun':
      return `<g id="hat">
  <path d="M96 92 C96 58 106 46 120 46 C134 46 144 58 144 92 Z" fill="${color}"/>
  <ellipse cx="120" cy="92" rx="70" ry="8" fill="${color}"/>
</g>`;
    default:
      return '';
  }
}

function costume(style) {
  if (style === 'dino') {
    return `<g id="costume">
  <path fill="#2E7D32" fill-rule="evenodd" d="M120 18 C70 18 46 58 46 108 C46 155 68 184 96 198 L88 220 L152 220 L144 198 C172 184 194 155 194 108 C194 58 170 18 120 18 Z M74 122 A46 50 0 0 0 120 172 A46 50 0 0 0 166 122 A46 50 0 0 0 120 72 A46 50 0 0 0 74 122 Z"/>
  <path d="M104 32 L120 6 L136 32 Z" fill="#1B5E20"/>
  <path d="M82 44 L60 16 L98 38 Z" fill="#1B5E20"/>
  <path d="M158 44 L180 16 L142 38 Z" fill="#1B5E20"/>
  <ellipse cx="94" cy="50" rx="11" ry="13" fill="#FFFFFF"/>
  <ellipse cx="146" cy="50" rx="11" ry="13" fill="#FFFFFF"/>
  <circle cx="96" cy="52" r="5.5" fill="#1A1A1A"/>
  <circle cx="148" cy="52" r="5.5" fill="#1A1A1A"/>
</g>`;
  }
  if (style === 'robot') {
    return `<g id="costume">
  <path fill="#78909C" fill-rule="evenodd" d="M120 26 C76 26 52 66 52 112 C52 156 76 186 120 194 C164 186 188 156 188 112 C188 66 164 26 120 26 Z M74 120 A46 48 0 0 0 120 168 A46 48 0 0 0 166 120 A46 48 0 0 0 120 72 A46 48 0 0 0 74 120 Z"/>
  <rect x="116" y="4" width="8" height="26" rx="3" fill="#607D8B"/>
  <circle cx="120" cy="6" r="7" fill="#4FC3F7"/>
  <circle cx="52" cy="116" r="11" fill="#B0BEC5" stroke="#546E7A" stroke-width="3"/>
  <circle cx="188" cy="116" r="11" fill="#B0BEC5" stroke="#546E7A" stroke-width="3"/>
</g>`;
  }
  return '';
}

export function composeAvatarHeadSvg(rawConfig) {
  const c = normalize(rawConfig);
  const parts = [
    `<rect x="36" y="28" width="168" height="160" fill="${c.backgroundColor}"/>`,
    head(c.skinTone),
    facialHair(c.facialHairStyle, c.facialHairColor),
    face(c.eyeStyle, c.eyeColor, c.skinTone),
    glasses(c.glassesStyle, c.glassesColor),
    hair(c.hairStyle, c.hairColor),
    hat(c.hatStyle, c.hatColor),
    costume(c.costumeStyle),
  ].filter(Boolean);

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="36 28 168 160" width="168" height="160">${parts.join('')}</svg>`;
}

export function avatarSvgDataUrl(rawConfig) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    composeAvatarHeadSvg(rawConfig),
  )}`;
}
